module.exports = __webpack_public_path__ + "/aba1dffb62632939999d1ce8678196b7.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/assets/send_icon_2.svg
 ** module id = 1114
 ** module chunks = 0
 **/